import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const PoolSnooker = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Pool/Snooker',
    category: 'Cue Sports',
    description: 'Relaxed environment for pool and snooker enthusiasts.',
    longDescription: 'Enjoy friendly competition and casual games at our Pool and Snooker Club. With professional-grade tables, regular tournaments, and a welcoming atmosphere, we bring together cue sports enthusiasts of all skill levels. Whether you are a seasoned player or just learning, you will find a home here.',
    images: [
      getImagePath('images/bars/pool_snooker.jpg'),
      getImagePath('images/bars/pool_snooker.jpg'),
      getImagePath('images/bars/pool_snooker.jpg')
    ],
    icon: 'fa-circle',
    members: '35+ active members',
    coach: 'Tournament Player Chuka Eze',
    schedule: 'Daily: 2pm - 11pm',
    level: 'All Levels',
    features: [
      'Professional Pool Tables',
      'Snooker Tables',
      'Tournament Play',
      'League Nights',
      'Equipment Rental',
      'Coaching Available',
      'Social Events',
      'Bar Service'
    ],
    facilities: ['Climate Controlled', 'Seating Area', 'Equipment Shop', 'Refreshments'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'cuesports@nlngraclub.com',
      extension: '209'
    },
    games: ['8-Ball Pool', '9-Ball Pool', 'Snooker', 'English Billiards'],
    events: ['Weekly Tournament', 'Monthly Championship', 'Doubles Night']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Club Pro</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Hours</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Games:</span>
                  <span className="info-value">{sectionData.games.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Events:</span>
                  <span className="info-value">{sectionData.events.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Tournament Schedule
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PoolSnooker;